import React, {Component} from 'react';
import "./ElementDetail.css"

class Element extends Component {
  render() {
    const content = this.props.element && (
      <React.Fragment>
        <div className="element-detail-title"> {this.props.element.Element}</div>
        <div><span>Z:</span> {this.props.element["Z"]}</div>
        <div><span>Symbol:</span> {this.props.element["Symbol"]}</div>
        <div><span>Element:</span> {this.props.element["Element"]}</div>
        <div><span>Origin of name:</span> {this.props.element["Origin of name"]}</div>
        <div><span>Group:</span> {this.props.element["Group"]}</div>
        <div><span>Period:</span> {this.props.element["Period"]}</div>
        <div><span>Atomic weight:</span> {this.props.element["Atomic weight"]}</div>
        <div><span>Density (g/cm3):</span> {this.props.element["Density (g/cm3)"]}</div>
        <div><span>Melt (K) :</span> {this.props.element["Melt (K) "]}</div>
        <div><span>Boil (K):</span> {this.props.element["Boil (K)"]}</div>
        <div><span>C (J/g · K):</span> {this.props.element["C (J/g · K)"]}</div>
        <div><span>χ:</span> {this.props.element["χ"]}</div>
        <div><span>Abundance in Earth's crust (mg/kg):</span> {this.props.element["Abundance in Earth's crust (mg/kg)"]}</div>
      </React.Fragment>
    );

    return (
      <div className="element-detail">
        {content}
      </div>
    );
  }
}

export default Element;



// WEBPACK FOOTER //
// ./src/components/ElementDetail.js